import { CarService } from "../../../service/car-service";
import { CarCatalogGatewayService } from "../../../service/car-catalog-gateway";

const fetchPincodeSearchDetails = (key) => () => {
    return new Promise((resolve, reject) => {
        CarService.fetchGeoSearchLoactionDetails(key)
            .then((response) => {
                resolve(response.data.detail);
            })
            .catch((error) => {
                reject(error);
            });

    });
};

const searchCityApi = (params) => () => {
    return new Promise((resolve, reject) => {
        CarCatalogGatewayService.fetchOnDemandCitySearch(params).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        });
    });
};

export {
    fetchPincodeSearchDetails,
    searchCityApi
};
